import { ValidatorService } from '../../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var $;

@Component({
  selector: 'app-select2-multi-groups',
  templateUrl: './select2-multi-groups.component.html',
  styleUrls: ['./select2-multi-groups.component.scss']
})
export class Select2MultiGroupsComponent implements OnInit {

  @Input() public default: string;
  @Input() public model: any;
  @Input() public options: any;
  @Input() public error: any; 
  @Input() public element: string;
  @Input() public response: string;
  @Input() public disabled: boolean = false;
  private data: any[];

  @Output() public SelectCallback: EventEmitter<any> = new EventEmitter;
  constructor(private validatorService: ValidatorService) {
  }

  ngOnInit() {

    if (this.element) {
      // se debe renombrar el this global para poder utilizarlo en el setTimeOut
      let that = this;

      // se debe colocar un timeout para que de tiempo de que se cargue el DOM
      setTimeout(() => {
        // iniciando input y recibiendo model
        that.input().select2({
          'placeholder': that.default,
          'multiple': true,
          'data': that.getData()
        });

        // enviamos al padre nuestro valor si es que hay cambios dentro del componente
        that.input().on('select2:select', function (e) {
          that.emit();
        });
        
        that.input().on('select2:unselect', function(e) {
          that.emit();
        });
      }, 500);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model || changes.options) {
      this.rebuild();
    }
  }

  rebuild() {
    this.input().empty();
    this.input().select2({
      'placeholder': this.default,
      'multiple': true,
      'data': this.getData()
    });
  }

  getData() {
    let that = this;
    // se recorre los grupos que se cuentan en las opciones
    that.data = $.map(that.options, (group) => {
      // se recorre los hijos de cada grupo
      $.map(group.children, (obj) => {
        // este nos sirve para saber si una opcion si se encuentra en los modelos
        let exists = false;
        // recorremos el array de modelos
        $.map(that.model, (model_item) => {
          // como cada grupo tiene su key, se busca si el modelo y la opcion tienen el mismo valor en el key grupal
          if(model_item[group['key']] == obj[group['key']]) {
            obj.selected = true;
            exists = true;
          }
        })
        // si no existe en los modelos se quita lo seleccionado
        if (! exists) {
          obj.selected = false;
        }
        // se le agrega un key unico para evitar que choquen entre keys
        obj.id = that.doUniqueValue(group, obj);
        obj.text = obj[group.label];
        return obj;
      })
      return group;
    });
    that.data.unshift({
      id: -1,
      text: this.default
    });
    console.log('data ', that.data);
    return that.data;
  }

  // emite la respuest al callback
  emit() {
    this.SelectCallback.emit(this.getResponse());
  }

  // regresamos valor actual del select en key o en model
  getResponse() {
    const input_array = this.input().val();
    const values_array = [];
    if (input_array && input_array.length > 0) {
      for (const input_item of input_array) {
        values_array.push(this.undoUniqueValue(input_item));
      }
    }
    return this.search(values_array);
  }

  search(values_array) {
    let find = [];

    for (const group of this.options) {
      for (const option of group.children) {
        for (const values_item of values_array) {
          if (values_item.group == group.text && values_item.option == option[group.key]) {
            find.push(option);
          }
        }
      }
    }
    console.log('search found ', find);
    return find;
  }

  input() {
    return $('#' + this.element);
  }

  doUniqueValue(group, option) {
    return this.getUniqueValueSelected(group, option);
  }
  undoUniqueValue(value) {
    const value_array = value.split('-');
    const group_name = value_array[0];
    const option_id = value_array[1];
    return {
      'group': group_name,
      'option': option_id
    };
  }
  getUniqueValueSelected(group, option) {
    return group.text + '-' + option[group.key];
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/select2/select2-multi-groups/select2-multi-groups.component.ts